"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ProductFoundComponent = _interopRequireDefault(require("../components/ProductFoundComponent"));
var _ProvisioningDeviceComponent = _interopRequireDefault(require("../components/ProvisioningDeviceComponent"));
var _RepalceFilterComponent = _interopRequireDefault(require("../components/RepalceFilterComponent"));
var _VsPumpSetupComponent = _interopRequireDefault(require("../components/VsPumpSetupComponent"));
var _QrCodeComponent = _interopRequireDefault(require("../components/QrCodeComponent"));
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _ServiceHistoryDetails = _interopRequireDefault(require("../components/ServiceHistoryDetails"));
var _browserImageCompression = _interopRequireDefault(require("browser-image-compression"));
var _strings = require("../common_features/utility/strings");
var _Services = require("../common_features/utility/Services");
var _reactRedux = require("react-redux");
var _PartSteper = _interopRequireDefault(require("../components/AddSystem/PartSteper"));
var _AddAccessoryComponent = _interopRequireDefault(require("../components/AddSystem/AddAccessoryComponent"));
var _AddAccessoryInstallationComponent = _interopRequireDefault(require("../components/AddSystem/AddAccessoryInstallationComponent"));
var _SubSteper = _interopRequireDefault(require("../components/AddSystem/SubSteper"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
var _ImageUpload = _interopRequireDefault(require("../components/ImageUpload"));
var _AddNotes = _interopRequireDefault(require("../components/AddNotes"));
var _helper = require("../common_features/utility/helper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const _ = require("underscore");
const AddSystem = () => {
  const windowLayout = (0, _helper.getPlatformType)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const dateValue = "";
  const inputValue = 10;
  const {
    selectedStore
  } = (0, _reactRedux.useSelector)(state => state.stores);
  const {
    selectedSystems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [serviceId, setServiceId] = (0, _react.useState)('');
  const [addSystemData, setAddSystemData] = (0, _react.useState)({
    description: "",
    partNumber: "",
    installedDate: "",
    selectedItems: {}
  });
  const [isRO, setRO] = (0, _react.useState)(false);
  const [imageCount, setImageCount] = (0, _react.useState)(0);
  const [details, setDetails] = (0, _react.useState)({
    InletTds: '',
    pretreatmentValue: false,
    InletHardness: '',
    InletTemp: '',
    InletPressure: '',
    pressureDrop: ''
  });
  const [partList, setPartList] = (0, _react.useState)([]);
  const [shouldCheckBoxDisabled, setShouldCheckBoxDisabled] = (0, _react.useState)(false);
  const [stepCount, setStepCount] = (0, _react.useState)(1);
  const [displayModal, setDisplayModal] = (0, _react.useState)(false);
  const [isOneSelected, setOneSelected] = (0, _react.useState)(!(0, _helper.getPlatformType)());
  const [cameraStream, setCameraStream] = (0, _react.useState)(false);
  const [selectedImages, setSelectedImages] = (0, _react.useState)([]);
  const [isLimitExceeded, setisLimitExceeded] = (0, _react.useState)(false);
  const [currentImage, setCurrentImage] = (0, _react.useState)(null);
  const [deleteModal, setdeleteModal] = (0, _react.useState)(false);
  const [isTwoSelected, setTwoSelected] = (0, _react.useState)((0, _helper.getPlatformType)());
  const [notesText, setNotesText] = (0, _react.useState)('');
  const [charCount, setCharCount] = (0, _react.useState)(250);
  const videoRef = (0, _react.useRef)(null);
  const [noImage, setNoImage] = (0, _react.useState)(false);
  const [showSuccessModal, setSuccessShowModal] = (0, _react.useState)(false);
  const [openWaterModal, setOpenWaterModal] = (0, _react.useState)(false);
  const [successModalData, setSuccessModalData] = (0, _react.useState)({});
  const [isUpdating, setIsUpdating] = (0, _react.useState)(false);
  const [updatedData, setUpdatedData] = (0, _react.useState)(null);
  const [accessoryList, setAccessoryList] = (0, _react.useState)([]);
  const [list, setList] = (0, _react.useState)([]);
  const [systemPartData, setSystemPartData] = (0, _react.useState)([]);
  const [steperComponent, setSteperComponent] = (0, _react.useState)([]);
  const [partStepCount, setPartStepCount] = (0, _react.useState)(0);
  const [count, setCount] = (0, _react.useState)(0);
  const [selectedPartItem, setSelectedPartItem] = (0, _react.useState)({});
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [totalPage, setTotalPage] = (0, _react.useState)(1);
  const [runCount, setRunCount] = (0, _react.useState)(1);
  const [listEnable, setlistEnable] = (0, _react.useState)(false);
  const [defaultSystem, setDefaultSystem] = (0, _react.useState)(null);
  const [nackNavigate, setBackNavigate] = (0, _react.useState)(false);
  const [dataLoading, setDataLoading] = (0, _react.useState)(false);
  const [systemDate, setSystemDate] = (0, _react.useState)("");
  const [description, setDescription] = (0, _react.useState)([]);
  const [systemImageData, setSystemImageData] = (0, _react.useState)({});
  const [detailsArray, setDetailsArray] = (0, _react.useState)([]);
  const [uploadingVisible, setUploadingVisible] = (0, _react.useState)(false);
  const [uploading, setUploading] = (0, _react.useState)(true);
  const [totalImagesUploaded, setTotalImagesUploaded] = (0, _react.useState)(0);
  const [totalImagesSelected, setTotalImagesSelected] = (0, _react.useState)(0);
  const [notUploaded, setNotUploaded] = (0, _react.useState)(false);
  const sysId = (0, _react.useRef)(0);
  const [serviceData, setServiceData] = (0, _react.useState)({});
  let [path, setImagePath] = (0, _react.useState)([]);
  let imagePathList = [];
  let imagePaths = [...imagePathList];
  (0, _react.useEffect)(() => {
    const customCall = async () => {
      if (selectedSystems.isComplete === false && runCount === 1) {
        await fetchSystemDetail(selectedSystems.systemPartNumber);
      }
    };
    customCall();
  }, []);
  (0, _react.useEffect)(() => {
    setRO(systemPartData["System Type"] === "RO System");
  }, []);
  (0, _react.useEffect)(() => {
    systemPartData["System Type"] === "RO System" && setDetails({
      ...details,
      PermeateTds: '',
      BlendedTds: '',
      RejectTds: '',
      PermeateFlowRate: '',
      RejectedFlow: '',
      preCharge: '',
      Recovery: ''
    });
  }, [systemPartData]);
  const handleBackNavigateAccept = () => {
    navigate(-1);
  };
  const handleBackNavigateCancel = () => {
    setBackNavigate(false);
  };
  const handleCrossIconAction = () => {
    setBackNavigate(false);
  };
  const warningSystemModalData = {
    variant: "cust-modal-header-icon",
    displayModal: true,
    modalHeaderIcon: false,
    displayCrossIcon: true,
    modalHeaderText: "Are you sure you want to exit?",
    modalHeaderTextStyle: {
      color: "#333333"
    },
    modalDetailText: "Pressing Exit will save your system as Incomplete Setup. However, you can resume & complete it later.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Exit",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleBackNavigateAccept(),
    negativeAction: () => handleBackNavigateCancel(),
    crossIconAction: () => handleCrossIconAction()
  };
  const initializeCount = () => {
    var _selectedSystems$Serv, _selectedSystems$Serv2, _selectedSystems$Serv3;
    let imagesArray = selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv === void 0 ? void 0 : (_selectedSystems$Serv2 = _selectedSystems$Serv[0]) === null || _selectedSystems$Serv2 === void 0 ? void 0 : (_selectedSystems$Serv3 = _selectedSystems$Serv2.ServiceLogImageUrls) === null || _selectedSystems$Serv3 === void 0 ? void 0 : _selectedSystems$Serv3.map(i => i.imageUrl);
    if ((imagesArray === null || imagesArray === void 0 ? void 0 : imagesArray.length) > 0) {
      let imageIndex = 0;
      const sortedArray = (0, _helper.sortAlphaNumericArray)(imagesArray);
      imageIndex = (0, _helper.extractNumberFromString)(sortedArray[0].substring(sortedArray[0].length - 10));
      imageIndex++;
      setImageCount(imageIndex);
    }
  };
  const handleStepBackCount = sequence => {
    if (partStepCount === 0) {
      handleBack();
      setCurrentPage(1);
    } else {
      if (sequence) {
        var _updatedData$partData;
        const data = updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData = updatedData.partData[sequence]) === null || _updatedData$partData === void 0 ? void 0 : _updatedData$partData.filter(item => item.isSelected);
        setSelectedPartItem({
          ...data[0]
        });
      }
      setCurrentPage(currentPage - 2);
      setPartStepCount(partStepCount - 1);
    }
  };
  const handleCountBack = () => {
    setCount(pre => pre - 1);
    setCurrentPage(currentPage - 1);
  };
  const handleVsContinueBtn = sequence => {
    var _updatedData$partData2;
    const data = updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData2 = updatedData.partData[sequence]) === null || _updatedData$partData2 === void 0 ? void 0 : _updatedData$partData2.filter(item => item.isSelected);
    setSelectedPartItem({
      ...data[0]
    });
    // }
    setCurrentPage(currentPage + 1);
    setCount(1);
  };
  const handleClick = (sequence, name, selectedItem) => {
    var _ref;
    const updatedItem = {
      ...selectedItem,
      isSelected: !selectedItem.isSelected
    };
    const updatedObj = (_ref = [...(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData[sequence])]) === null || _ref === void 0 ? void 0 : _ref.map(item => item["Model Number"] === name ? {
      ...updatedItem
    } : {
      ...item,
      isSelected: false
    });
    const updatedPartData = {
      ...(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)
    };
    updatedPartData[sequence] = updatedObj;
    setUpdatedData({
      ...updatedData,
      partData: updatedPartData
    });
    setSelectedPartItem({
      ...updatedItem
    });
  };
  const handleBtnSelect = arr => {
    for (let item of arr) {
      if (item.isSelected) {
        return true;
      }
    }
    return false;
  };
  const handleContinue = isFinish => {
    setCount(0);
    handleAddSystem();
    if (isFinish) {
      handleStepCount();
    } else {
      setPartStepCount(pre => pre + 1);
    }
    setCurrentPage(currentPage + 1);
  };
  const handlePartDateChange = (date, sequence) => {
    var _ref2;
    const updatedItem = {
      ...selectedPartItem,
      selectedDate: date
    };
    const updatedObj = (_ref2 = [...(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData[sequence])]) === null || _ref2 === void 0 ? void 0 : _ref2.map(item => item["Model Number"] === updatedItem["Model Number"] ? {
      ...selectedPartItem,
      selectedDate: date
    } : {
      ...item
    });
    const updatedPartData = {
      ...updatedData.partData
    };
    updatedPartData[sequence] = updatedObj;
    setUpdatedData({
      ...updatedData,
      partData: updatedPartData
    });
    setSelectedPartItem({
      ...updatedItem
    });
  };
  const handleInputValue = (value, sequence) => {
    var _ref3;
    const updatedItem = {
      ...selectedPartItem,
      selectedSlider: value
    };
    const updatedObj = (_ref3 = [...(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData[sequence])]) === null || _ref3 === void 0 ? void 0 : _ref3.map(item => item["Model Number"] === updatedItem["Model Number"] ? {
      ...selectedPartItem,
      selectedSlider: value
    } : {
      ...item
    });
    const updatedPartData = {
      ...updatedData.partData
    };
    updatedPartData[sequence] = updatedObj;
    setUpdatedData({
      ...updatedData,
      partData: updatedPartData
    });
    setSelectedPartItem({
      ...updatedItem
    });
  };
  const handleCheckDisability = data => {
    for (let item of data) {
      if (item.isSelected) return false;
    }
    return true;
  };
  const handleBackStoreDashboard = () => {
    if (sysId.current || !_.isEmpty(selectedSystems)) {
      setBackNavigate(true);
    } else {
      navigate(-1);
    }
  };
  const getSliderValue = val => {
    if (val % 2 === 0) {
      return val / 2;
    } else {
      return Math.floor(val / 2);
    }
  };
  (0, _react.useEffect)(() => {
    if (updatedData) {
      var _Object$keys;
      const componentArray = [];
      if (((_Object$keys = Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
        var _Object$keys2;
        (_Object$keys2 = Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.forEach((value, index) => {
          var _updatedData$partData3, _updatedData$partData4, _updatedData$partData5, _updatedData$partData6, _updatedData$partData7, _updatedData$partData8;
          let upDatedAList = updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData3 = updatedData.partData[value]) === null || _updatedData$partData3 === void 0 ? void 0 : _updatedData$partData3.map(item => {
            return {
              ...item,
              name: item["Model Number"],
              color: "#".concat(item["SKU Label Color"])
            };
          });
          componentArray.push( /*#__PURE__*/_react.default.createElement(_SubSteper.default, {
            totalPage: totalPage,
            currentPage: currentPage,
            modelNumber: updatedData.system_id + " " + updatedData["Model Number"],
            sequence: value,
            list: upDatedAList,
            setCount: setCount,
            dateChange: handlePartDateChange,
            handleClick: handleClick,
            handleSaveBtn: () => {
              var _Object$keys3;
              return handleContinue(((_Object$keys3 = Object.keys(updatedData.partData)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.length) === index + 1);
            },
            handleInputValue: handleInputValue,
            count: count,
            value: selectedPartItem.selectedDate,
            inputValue: selectedPartItem.selectedSlider,
            updatedData: updatedData.partData[value],
            continueBtnDisabled: handleCheckDisability(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData[value]),
            rightNavHeading: "Cancel",
            vsNavHeading: "".concat(partStepCount === 0 ? "Add System" : "Previous Filter"),
            vsHeaderText: "Please Select ".concat(updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData4 = updatedData.partData[value][0]) === null || _updatedData$partData4 === void 0 ? void 0 : _updatedData$partData4["reference_application"]),
            eaHeaderText: "".concat(updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData5 = updatedData.partData[value][0]) === null || _updatedData$partData5 === void 0 ? void 0 : _updatedData$partData5["reference_application"], " Reminder for ").concat(updatedData.system_id, " ").concat(updatedData["Model Number"]),
            handleCountBack: handleCountBack,
            handleStepBackCount: () => handleStepBackCount(value),
            vsSubContent: "Add the ".concat(updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData6 = updatedData.partData[value][0]) === null || _updatedData$partData6 === void 0 ? void 0 : _updatedData$partData6["reference_application"], " for the system that is installed."),
            vsContinueBtnTitle: "Continue",
            continueBtnClick: handleVsContinueBtn,
            backNavigationScreen: "Choose Filter",
            eaSubContent: "When was the ".concat(updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData7 = updatedData.partData[value][0]) === null || _updatedData$partData7 === void 0 ? void 0 : _updatedData$partData7["reference_application"], " installed?"),
            inputLabel: "Installation  Date",
            saveBtnTitle: "Save and Continue",
            editSliderLabel: "Estimated ".concat(updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$partData8 = updatedData.partData[value][0]) === null || _updatedData$partData8 === void 0 ? void 0 : _updatedData$partData8["reference_application"], " Life"),
            adjustReplacementText: "Adjust estimated filter life if needed. ",
            handleCancelbtn: handleCancelbtn,
            saveBtnDisabled: !(selectedPartItem.selectedDate && selectedPartItem.selectedSlider),
            handleBtnSelect: handleBtnSelect,
            sliderMin: 1,
            sliderMax: selectedPartItem["Estimated Filter Life (months)"],
            inputNumberMin: 1,
            inputNumberMax: selectedPartItem["Estimated Filter Life (months)"],
            sliderLeftText: "1 mo.",
            sliderRightText: "".concat(selectedPartItem["Estimated Filter Life (months)"], " mos."),
            minInstallationDate: new Date(systemDate),
            maxInstallationDate: new Date()
          }));
        });
      }
      setSteperComponent(componentArray);
    }
  }, [updatedData, count, partStepCount, inputValue, dateValue, stepCount]);
  const handleReduceBtn = item => {
    let arr = accessoryList === null || accessoryList === void 0 ? void 0 : accessoryList.map(acc => {
      return acc["Model Number"] === item ? {
        ...acc,
        count: acc.count === 0 ? 0 : acc.count - 1
      } : acc;
    });
    setAccessoryList(arr);
  };
  const handleAddBtn = item => {
    let arr = accessoryList === null || accessoryList === void 0 ? void 0 : accessoryList.map(acc => {
      return acc["Model Number"] === item ? {
        ...acc,
        count: acc.count === 9 ? 9 : (acc.count || 0) + 1
      } : acc;
    });
    setAccessoryList(arr);
  };
  const createUpdatedList = prod => {
    let newArr = [];
    prod === null || prod === void 0 ? void 0 : prod.map(item => {
      var _Array$from;
      (_Array$from = Array.from({
        length: item.count
      })) === null || _Array$from === void 0 ? void 0 : _Array$from.forEach((i, index) => {
        let name = "".concat(item["Model Number"], " GAL Tank (").concat(item.count === 1 ? "" : index + 1, ")");
        newArr.push({
          ...item,
          "Model Number": name
        });
      });
    });
    setList(newArr);
  };
  const dateChange = (d, name) => {
    let arr = list === null || list === void 0 ? void 0 : list.map(acc => {
      if (acc["Model Number"] === name) {
        return {
          ...acc,
          selectedDate: d
        };
      } else {
        return acc;
      }
    });
    setList(arr);
  };
  const handleCancelbtn = () => {
    navigate(-1);
  };
  const fetchList = async () => {
    try {
      const listData = await (0, _Services.listSystems)();
      let abc = [];
      listData === null || listData === void 0 ? void 0 : listData.map(item => {
        var _item$asset;
        return abc.push({
          system_id: item.system_id,
          model_number: item.model_number,
          image_url: (_item$asset = item.asset) === null || _item$asset === void 0 ? void 0 : _item$asset.url
        });
      });
      setPartList(abc);
    } catch (error) {
      console.log(error, "fetchList api error");
    }
  };
  const fetchSystemDetail = async systemId => {
    setIsLoading(true);
    try {
      const systemData = await (0, _Services.GetAddSystemDetails)(systemId);
      setSystemPartData(systemData);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      alert(error);
      setStepCount(1);
      let emp = {
        ...addSystemData
      };
      emp.description = "";
      setAddSystemData({
        ...emp
      });
      console.log(error, "fetchSystemDetail");
    }
  };
  const handleWaterModal = modal => {
    setOpenWaterModal(modal);
  };
  const handleBack = () => {
    setStepCount(stepCount - 1);
    setCurrentPage(currentPage - 1);
  };
  const handleBack1 = () => {
    setStepCount(1);
  };
  const calculateRecovery = () => {
    const numerator = Number(details === null || details === void 0 ? void 0 : details.PermeateFlowRate);
    const denominator = Number(details === null || details === void 0 ? void 0 : details.PermeateFlowRate) + Number(details === null || details === void 0 ? void 0 : details.RejectedFlow);
    const recovery = numerator / denominator * 100;
    return +parseFloat(recovery).toFixed(2);
  };
  const handleStepCount = () => {
    var _Object$keys4, _updatedData$accessor, _Object$keys5, _Object$keys6, _updatedData$accessor2;
    if (((_Object$keys4 = Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)) === null || _Object$keys4 === void 0 ? void 0 : _Object$keys4.length) === 0 && stepCount === 3) {
      setStepCount(5);
      handleAddSystem();
    } else if (stepCount === 1) {
      dispatch((0, _systemsReducer.selectSystems)({}));
      if (selectedSystems.isComplete !== false && !defaultSystem) {
        fetchSystemDetail(JSON.parse(addSystemData.description).system_id);
      }
      setStepCount(pre => pre + 1);
    } else if ((updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$accessor = updatedData.accessoryData) === null || _updatedData$accessor === void 0 ? void 0 : _updatedData$accessor.length) === 0 && stepCount === 3 && ((_Object$keys5 = Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)) === null || _Object$keys5 === void 0 ? void 0 : _Object$keys5.length) > 0) {
      setStepCount(stepCount + 1);
      handleAddSystem();
    } else if (((_Object$keys6 = Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)) === null || _Object$keys6 === void 0 ? void 0 : _Object$keys6.length) > 0 && (updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$accessor2 = updatedData.accessoryData) === null || _updatedData$accessor2 === void 0 ? void 0 : _updatedData$accessor2.length) === 0 && stepCount === 4) {
      setStepCount(7);
    } else if (stepCount === 8) {
      isRO && setDetails({
        ...details,
        Recovery: details !== null && details !== void 0 && details.PermeateFlowRate && details !== null && details !== void 0 && details.RejectedFlow ? calculateRecovery() : '--'
      });
      setCurrentPage(currentPage + 1);
      handleAddSystem();
      setStepCount(stepCount + 1);
    } else if (stepCount === 7 || stepCount === 9) {
      setCurrentPage(currentPage + 1);
      handleAddSystem();
      setStepCount(stepCount + 1);
    } else if (stepCount === 5 || stepCount === 6) {
      if (stepCount == 6) {
        handleAddSystem();
      }
      setStepCount(stepCount + 1);
      setCurrentPage(currentPage + 1);
    } else {
      if (stepCount == 3) {
        handleAddSystem();
      }
      setStepCount(stepCount + 1);
    }
  };
  const handleLastStepBack = () => {
    var _updatedData$accessor3, _Object$keys7;
    if ((updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$accessor3 = updatedData.accessoryData) === null || _updatedData$accessor3 === void 0 ? void 0 : _updatedData$accessor3.length) === 0 && ((_Object$keys7 = Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)) === null || _Object$keys7 === void 0 ? void 0 : _Object$keys7.length) > 0) {
      setStepCount(stepCount - 3);
      setCurrentPage(currentPage - 2);
    } else {
      setStepCount(stepCount - 1);
      setCurrentPage(currentPage - 1);
    }
  };
  const handleData = (key, value) => {
    const currentValue = {
      ...addSystemData
    };
    currentValue[key] = value;
    setAddSystemData({
      ...currentValue
    });
    if (key === "description") {
      const selectedPartDetails = partList.find(item => item.system_id === JSON.parse(value).system_id);
      if (selectedPartDetails) {
        setSystemImageData(selectedPartDetails);
      } else {
        setSystemImageData(null);
      }
    }
  };
  const handleCheckBoxSelection = (key, value) => {
    let obj = {
      ...addSystemData.selectedItems
    };
    obj[key] = value;
    setAddSystemData({
      ...addSystemData,
      selectedItems: {
        ...obj
      }
    });
  };
  const handleSuccessModal = () => {
    navigate(-1);
  };
  const structureSelectedItems = selectItems => {
    let myArr = [];
    for (let item of Object.keys(selectItems)) {
      if (selectItems[item]) myArr.push({
        name: item
      });
    }
    return myArr;
  };
  const onChangeNotes = event => {
    const inputVal = event.target.value;
    if ((inputVal === null || inputVal === void 0 ? void 0 : inputVal.length) <= 250) {
      setNotesText(inputVal);
      setCharCount(250 - (inputVal === null || inputVal === void 0 ? void 0 : inputVal.length));
    }
  };
  const handleAddSystem = () => {
    var _selectedStore$Organi;
    if (stepCount === 10) {
      setIsUpdating(true);
    }
    let payLoadPartData = [];
    let payLoadAccessoryData = [];
    for (let item of Object.keys(updatedData.partData)) {
      var _updatedData$partData9, _updatedData$partData10;
      const partDataArray = (_updatedData$partData9 = updatedData.partData[item]) === null || _updatedData$partData9 === void 0 ? void 0 : (_updatedData$partData10 = _updatedData$partData9.filter(i => i.isSelected)) === null || _updatedData$partData10 === void 0 ? void 0 : _updatedData$partData10.map(d => {
        var _d$asset, _d$asset2;
        return {
          sequence: parseInt(d === null || d === void 0 ? void 0 : d.sequence),
          refAppType: "Replacement Part",
          refAppPartNumber: d === null || d === void 0 ? void 0 : (_d$asset = d.asset) === null || _d$asset === void 0 ? void 0 : _d$asset.sku_id,
          refAppName: d === null || d === void 0 ? void 0 : d.reference_application,
          refAppLife: d["Estimated Filter Life (months)"],
          selectedRefAppLife: d === null || d === void 0 ? void 0 : d.selectedSlider,
          refAppImageUrl: d === null || d === void 0 ? void 0 : (_d$asset2 = d.asset) === null || _d$asset2 === void 0 ? void 0 : _d$asset2.url,
          refAppModelNumber: d["Model Number"],
          refAppInstallationDate: new Date(d === null || d === void 0 ? void 0 : d.selectedDate).toString()
        };
      });
      payLoadPartData.push(...partDataArray);
    }
    payLoadAccessoryData = list === null || list === void 0 ? void 0 : list.map(item => {
      var _item$asset2;
      return {
        refAppType: "Accessory",
        refAppPartNumber: "#".concat(item.asset.sku_id),
        refAppName: item === null || item === void 0 ? void 0 : item.reference_application,
        refAppImageUrl: item === null || item === void 0 ? void 0 : (_item$asset2 = item.asset) === null || _item$asset2 === void 0 ? void 0 : _item$asset2.url,
        refAppModelNumber: item["Model Number"],
        refAppInstallationDate: item === null || item === void 0 ? void 0 : item.selectedDate,
        sequence: 0
      };
    });
    let ServiceLogImageUrls = [];
    console.log('imagePaths API length<><>', imagePaths, path.length);
    if (path !== null && path !== void 0 && path.length) {
      for (let i = 0; i < path.length; i++) {
        ServiceLogImageUrls.push({
          "imageUrl": path[i] || '',
          "imageDescription": description[i] || ''
        });
      }
    }
    const ServiceLogReading = {
      ServiceLogReading: {
        readings: {
          ...details,
          pretreatmentValue: details !== null && details !== void 0 && details.pretreatmentValue ? 'Yes' : 'No'
        }
      }
    };
    const ServiceLogNote = {
      ServiceLogNote: {
        note: notesText
      },
      ...(!notesText && {
        ServiceLogNote: {}
      })
    };
    const imagePayload = {
      ServiceLogImageUrls: ServiceLogImageUrls
    };
    let systemData = {
      systemDetails: {
        partNumber: JSON.parse(addSystemData.description).system_id,
        description: JSON.parse(addSystemData.description).model_number
      },
      systemId: stepCount >= 3 && sysId.current ? sysId.current : null,
      serviceId: stepCount > 7 && serviceId ? serviceId : null,
      isComplete: stepCount === 10 ? true : false,
      waterDest: stepCount >= 7 ? structureSelectedItems(addSystemData.selectedItems) : [],
      installedDate: new Date(addSystemData.installedDate).toString(),
      storeId: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.storeId,
      orgId: selectedStore === null || selectedStore === void 0 ? void 0 : (_selectedStore$Organi = selectedStore.Organization) === null || _selectedStore$Organi === void 0 ? void 0 : _selectedStore$Organi.orgId,
      systemAccessoryRecords: [...payLoadPartData, ...payLoadAccessoryData],
      ...(stepCount > 7 && ServiceLogReading),
      ...(stepCount > 8 && imagePayload),
      ...(stepCount > 9 && ServiceLogNote)
    };
    setSuccessShowModal(false);
    systemData = Object.fromEntries(Object.entries(systemData).filter(_ref4 => {
      let [key, value] = _ref4;
      return value !== null;
    }));
    if (stepCount === 3 && _.isEmpty(selectedSystems)) {
      setDataLoading(true);
    }
    if (stepCount === 8 || stepCount === 9 || stepCount === 7) {
      setIsUpdating(true);
    }
    (0, _Services.addSystem)({
      ...systemData
    }).then(data => {
      var _data$data$serviceLog, _data$data, _data$data$serviceLog2, _data$data$serviceLog3, _data$data2, _data$data2$systemDat, _data$data3, _data$data3$systemDat, _data$data4, _data$data4$systemDat;
      setServiceId((_data$data$serviceLog = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$serviceLog2 = _data$data.serviceLogsData) === null || _data$data$serviceLog2 === void 0 ? void 0 : (_data$data$serviceLog3 = _data$data$serviceLog2.serviceLogsData) === null || _data$data$serviceLog3 === void 0 ? void 0 : _data$data$serviceLog3.serviceId) !== null && _data$data$serviceLog !== void 0 ? _data$data$serviceLog : '');
      setSystemDate(data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : (_data$data2$systemDat = _data$data2.systemData) === null || _data$data2$systemDat === void 0 ? void 0 : _data$data2$systemDat.installedDate);
      dispatch((0, _systemsReducer.setPartialSysLoading)(true));
      setlistEnable(true);
      setIsUpdating(false);
      setServiceData(data.data);
      setDefaultSystem((data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : (_data$data3$systemDat = _data$data3.systemData) === null || _data$data3$systemDat === void 0 ? void 0 : _data$data3$systemDat.systemPartNumber) + " " + (data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : (_data$data4$systemDat = _data$data4.systemData) === null || _data$data4$systemDat === void 0 ? void 0 : _data$data4$systemDat.systemModelNumber));
      if (stepCount === 10) {
        setSuccessModalData({
          type: "success",
          data
        });
        setSuccessShowModal(true);
        setIsUpdating(false);
        dispatch((0, _systemsReducer.setPartialSysLoading)(false));
      }
      if (stepCount === 3 && _.isEmpty(selectedSystems)) {
        var _data$data5, _data$data5$systemDat;
        sysId.current = data === null || data === void 0 ? void 0 : (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : (_data$data5$systemDat = _data$data5.systemData) === null || _data$data5$systemDat === void 0 ? void 0 : _data$data5$systemDat.systemId;
        setDataLoading(false);
      }
    }).catch(error => {
      setSuccessModalData({
        type: "error",
        error
      });
      setSuccessShowModal(true);
      setIsUpdating(false);
    });
  };
  const handleAccessoryBack = () => {
    var _Object$keys8;
    if (((_Object$keys8 = Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData)) === null || _Object$keys8 === void 0 ? void 0 : _Object$keys8.length) > 0) {
      handleBack();
      setCount(0);
    } else {
      setStepCount(3);
    }
    setCurrentPage(currentPage - 2);
  };
  (0, _react.useEffect)(() => {
    fetchList();
  }, []);
  const fetchImage = async () => {
    var _selectedSystems$Serv4, _selectedSystems$Serv5;
    let image = selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv4 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv5 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv5 === void 0 ? void 0 : _selectedSystems$Serv5.length) - 1].ServiceLogImageUrls) === null || _selectedSystems$Serv4 === void 0 ? void 0 : _selectedSystems$Serv4.map(i => i.imageUrl);
    let result = [];
    try {
      setIsUpdating(true);
      await Promise.all(image === null || image === void 0 ? void 0 : image.map(async imgPath => {
        const resp = await (0, _Services.imageGet)(imgPath);
        const blobData = b64toBlob(atob(resp).split(',')[1].slice(0, -1));
        result.push(blobData);
        const imgArray = result.map(file => {
          return URL.createObjectURL(file);
        });
        setSelectedImages(imgArray);
      }));
      setUploading(false);
      setIsUpdating(false);
    } catch (error) {
      setIsUpdating(false);
      setUploading(false);
      console.log(error, "fetchImage api error");
    }
  };
  (0, _react.useEffect)(() => {
    const myArr = [];
    for (let item of Object.keys(addSystemData.selectedItems)) {
      if (addSystemData.selectedItems[item]) {
        myArr.push(item);
      }
    }
    myArr.length === 4 ? setShouldCheckBoxDisabled(true) : setShouldCheckBoxDisabled(false);
  }, [addSystemData.selectedItems]);
  (0, _react.useEffect)(() => {
    let obj = {};
    for (let si of _strings.items) {
      obj[si] = false;
    }
    // { i1: false, i2: false }
    setAddSystemData({
      ...addSystemData,
      selectedItems: {
        ...obj
      }
    });
  }, []);
  (0, _react.useEffect)(() => {
    var _systemPartData$refer, _systemPartData$refer2, _systemPartData$refer3;
    const filterData = _.groupBy(systemPartData === null || systemPartData === void 0 ? void 0 : (_systemPartData$refer = systemPartData.reference_ids) === null || _systemPartData$refer === void 0 ? void 0 : _systemPartData$refer.filter(item => item.reference_type !== "Accessory"), "sequence");
    const updatedFilterData = {};
    let page = Object.keys(filterData).length * 2 + 4;
    for (let item of Object.keys(filterData)) {
      var _filterData$item;
      const obj = (_filterData$item = filterData[item]) === null || _filterData$item === void 0 ? void 0 : _filterData$item.map(filt => ({
        ...filt,
        isSelected: false,
        selectedDate: "",
        selectedSlider: getSliderValue(parseInt(filt === null || filt === void 0 ? void 0 : filt["Estimated Filter Life (months)"]))
      }));
      updatedFilterData[item] = obj;
    }
    const accessoryData = systemPartData === null || systemPartData === void 0 ? void 0 : (_systemPartData$refer2 = systemPartData.reference_ids) === null || _systemPartData$refer2 === void 0 ? void 0 : (_systemPartData$refer3 = _systemPartData$refer2.filter(item => item.reference_type === "Accessory")) === null || _systemPartData$refer3 === void 0 ? void 0 : _systemPartData$refer3.map(i => ({
      ...i,
      count: 0,
      selectedDate: ""
    }));
    page = _.isEmpty(accessoryData) ? page : page + 2;
    setTotalPage(page);
    const sortedArray = accessoryData === null || accessoryData === void 0 ? void 0 : accessoryData.sort((a, b) => parseInt(b["Model Number"].slice(2)) - parseInt(a["Model Number"].slice(2)));
    setAccessoryList(sortedArray);
    setUpdatedData({
      ...systemPartData,
      partData: updatedFilterData,
      accessoryData
    });
  }, [systemPartData]);
  const pretreatmentChecked = () => {
    setDetails({
      ...details,
      pretreatmentValue: !details.pretreatmentValue
    });
  };
  const handleAccessoryBtnDisable = () => {
    for (let item of accessoryList) {
      if (item.count > 0) {
        return false;
      }
    }
    return true;
  };
  const handleAccInstallationBtn = () => {
    for (let item of list) {
      if (item.selectedDate === "") {
        return true;
      }
    }
    return false;
  };
  const newStep = () => {
    setStepCount(stepCount - 1);
  };
  (0, _react.useEffect)(() => {
    createUpdatedList(accessoryList);
  }, [accessoryList]);
  (0, _react.useEffect)(() => {
    var _detailsKey;
    let detailInfo = '';
    if (notesText.length != 0) {
      detailInfo += 'Notes';
    }
    let detailsKey;
    if (details) detailsKey = Object.keys(details);
    (_detailsKey = detailsKey) === null || _detailsKey === void 0 ? void 0 : _detailsKey.forEach(k => {
      if (details !== null && details !== void 0 && details[k]) {
        if (!detailInfo.includes("Water Details")) {
          detailInfo += "".concat(detailInfo.length !== 0 ? ',' : '') + 'Water Details';
        }
      }
    });
    if ((selectedImages === null || selectedImages === void 0 ? void 0 : selectedImages.length) !== 0) {
      if (detailInfo.length != 0) detailInfo += ' and ';
      detailInfo += 'Photos';
    }
    if (detailInfo.length != 0) detailInfo += ' has been added.';
    setDetailsArray(detailInfo);
  }, [details, notesText, selectedImages]);
  const searchByPair = arr => {
    return arr.find(o => o.refAppType === "Accessory") || false;
  };
  const uploadPhotos = () => {
    setDisplayModal(true);
  };
  const onOptionSelect = key => {
    if (key === 1) {
      setOneSelected(true);
      setTwoSelected(false);
    } else {
      setTwoSelected(true);
      setOneSelected(false);
    }
  };
  /**
   * @param {*} b64Data | The Base 64 encoded Data to convert into BLOB URL's.
   * @param {*} contentType | Content-Type of Image : Image/png.
   * @param {*} sliceSize | Default : 512.
   * @returns | Blob URL of the Image.
   */
  const b64toBlob = function (b64Data) {
    let contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType
    });
    return blob;
  };
  /**
   * @param {*} file : The Image File Uploaded from Device to convert it into Base 64 format.
   * @returns base64 encoded image files.
   */
  //Code to Upload the Image to s3 via API Gateway (API Gateway Proxy Integration).
  const handleFileUpload = async (img, index) => {
    var _serviceData$serviceL, _serviceData$serviceL2;
    const file = img;
    const base64 = await (0, _helper.convertToBase64)(file);
    const imageIndex = imageCount + index;
    let serviceId = serviceData === null || serviceData === void 0 ? void 0 : (_serviceData$serviceL = serviceData.serviceLogsData) === null || _serviceData$serviceL === void 0 ? void 0 : (_serviceData$serviceL2 = _serviceData$serviceL.serviceLogsData) === null || _serviceData$serviceL2 === void 0 ? void 0 : _serviceData$serviceL2.serviceId;
    await (0, _Services.imageUpload)(base64, "/".concat(sysId.current, "/").concat(serviceId, "/systemImage-").concat(imageIndex, ".png"));
    imagePaths.push("/".concat(sysId.current, "/").concat(serviceId, "/systemImage-").concat(imageIndex, ".png"));
    setImagePath(prev => [...prev, "/".concat(sysId.current, "/").concat(serviceId, "/systemImage-").concat(imageIndex, ".png")]);
  };
  const uploadImages = async imageFiles => {
    try {
      await Promise.all(imageFiles.map(async (img, index) => {
        await handleFileUpload(img, index);
      }));
      setTotalImagesUploaded(imageFiles.length);
      setImageCount(imageCount + imageFiles.length);
    } catch (error) {
      console.log(error, "uploadImages api error");
      setNotUploaded(true);
    }
  };
  const imageNotUploadedClick = () => {
    setNotUploaded(false);
  };
  const handleFileChange = async event => {
    setDisplayModal(false);
    setUploadingVisible(true);
    const imageFile = event.target.files;
    setTotalImagesSelected(imageFile.length);
    let selectedFiles = [];
    const options = {
      maxSizeMB: 6,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    if (imageFile.length > 10) {
      if (path.length === 0) setNoImage(true);
      setisLimitExceeded(true);
    } else {
      setNoImage(false);
      try {
        const compressedFiles = await Promise.all(Array.from(imageFile).map(async file => {
          const compressedFile = await (0, _browserImageCompression.default)(file, options);
          return compressedFile;
        }));
        selectedFiles = selectedFiles.concat(compressedFiles);
      } catch (error) {
        console.log(error);
      }
      setIsUpdating(true);
      if (path.length <= 10 && selectedFiles.length + path.length <= 10) {
        var _selectedFiles;
        await uploadImages(selectedFiles);
        const imagesArray1 = (_selectedFiles = selectedFiles) === null || _selectedFiles === void 0 ? void 0 : _selectedFiles.map(file => {
          return URL.createObjectURL(file);
        });
        setSelectedImages(previousImages => previousImages.concat(imagesArray1));
        setUploading(false);
        setIsUpdating(false);
      } else {
        setIsUpdating(false);
        setUploading(false);
        setisLimitExceeded(true);
      }
    }
    // FOR BUG IN CHROME
    event.target.value = "";
  };
  const onKeyPress = event => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };
  const onModalCancel = () => {
    setTwoSelected((0, _helper.getPlatformType)());
    setOneSelected(!(0, _helper.getPlatformType)());
    setDisplayModal(false);
  };
  const limitOkPress = () => {
    setisLimitExceeded(false);
  };
  const deleteIconClick = image => {
    setCurrentImage(image);
    setdeleteModal(true);
  };
  const onCancelDelete = () => {
    setdeleteModal(false);
  };
  const deleteHandler = () => {
    setdeleteModal(false);
    setUploadingVisible(false);
    const indexInSelectedImages = selectedImages.indexOf(currentImage);
    if (indexInSelectedImages !== -1) {
      const updatedSelectedImages = selectedImages.filter((e, index) => index !== indexInSelectedImages);
      setSelectedImages(updatedSelectedImages);
      const updatedPath = path.filter((e, index) => index !== indexInSelectedImages);
      setImagePath(updatedPath);
    }
    URL.revokeObjectURL(currentImage);
    setUploading(false);
  };
  (0, _react.useEffect)(() => {
    const customcall = async () => {
      if (selectedSystems.isComplete === false) {
        var _selectedSystems$Serv6, _selectedSystems$Serv7, _selectedSystems$Serv8, _selectedSystems$Serv9, _selectedSystems$Serv10, _selectedSystems$Serv11, _selectedSystems$Serv12;
        setSystemDate(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.installedDate);
        let partStepLength = 0;
        sysId.current = selectedSystems.systemId;
        setServiceId((_selectedSystems$Serv6 = selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv7 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv9 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv9 === void 0 ? void 0 : _selectedSystems$Serv9.length) - 1]) === null || _selectedSystems$Serv7 === void 0 ? void 0 : (_selectedSystems$Serv8 = _selectedSystems$Serv7.ServiceLogReadings[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv10 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv12 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv12 === void 0 ? void 0 : _selectedSystems$Serv12.length) - 1]) === null || _selectedSystems$Serv10 === void 0 ? void 0 : (_selectedSystems$Serv11 = _selectedSystems$Serv10.ServiceLogReadings) === null || _selectedSystems$Serv11 === void 0 ? void 0 : _selectedSystems$Serv11.length) - 1]) === null || _selectedSystems$Serv8 === void 0 ? void 0 : _selectedSystems$Serv8.serviceId) !== null && _selectedSystems$Serv6 !== void 0 ? _selectedSystems$Serv6 : '');
        setlistEnable(true);
        setDefaultSystem(selectedSystems.systemPartNumber + " " + selectedSystems.systemModelNumber);
        setSystemImageData({
          image_url: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemImageUrl
        });
        initializeCount();
        let partSequenceMax = null;
        let fullSequenceMax = null;
        const partialData = selectedSystems;
        const partialSequence = _.isEmpty(partialData.SystemReferenceMappings) ? [0] : _.pluck(partialData.SystemReferenceMappings, "sequence");
        partSequenceMax = Math.max(...partialSequence);
        const fullSequence = _.isEmpty(systemPartData.reference_ids) ? [0] : _.pluck(systemPartData.reference_ids, "sequence");
        fullSequenceMax = Math.max(...fullSequence);
        if (runCount <= 4) {
          var _Object$keys9, _updatedData$accessor4;
          setRunCount(pre => pre + 1);
          setAddSystemData({
            description: JSON.stringify({
              "system_id": "".concat(selectedSystems.systemPartNumber),
              "model_number": "".concat(selectedSystems.systemModelNumber)
            }),
            partNumber: "",
            installedDate: new Date(selectedSystems.installedDate),
            selectedItems: {}
          });
          if (updatedData && ((_Object$keys9 = Object.keys(updatedData.partData)) === null || _Object$keys9 === void 0 ? void 0 : _Object$keys9.length) > 0) {
            selectedSystems.SystemReferenceMappings.forEach(list => {
              if (list.refAppType !== "Accessory") {
                const item = updatedData.partData[list.sequence];
                item.forEach(ref => {
                  if (ref.reference_id === list.refAppPartNumber) {
                    ref.isSelected = true;
                    ref.selectedDate = new Date(list.refAppInstallationDate);
                    ref.selectedSlider = list.selectedRefAppLife;
                    partStepLength = partStepLength + 1;
                  }
                });
              }
            });
          }
          if (updatedData && ((_updatedData$accessor4 = updatedData.accessoryData) === null || _updatedData$accessor4 === void 0 ? void 0 : _updatedData$accessor4.length) > 0) {
            let addedAccessoryList = [];
            let currentAccessoryList = [];
            selectedSystems.SystemReferenceMappings.forEach(i => {
              if (i.refAppType === "Accessory") {
                addedAccessoryList.push(i);
              }
            });
            updatedData.accessoryData.forEach(i => {
              addedAccessoryList.forEach(list => {
                if (i.reference_id === list.refAppPartNumber.slice(1)) {
                  i.count = i.count + 1;
                  i.selectedDate = new Date(list.refAppInstallationDate);
                  currentAccessoryList.push(i);
                }
              });
            });
            if (!_.isEmpty(currentAccessoryList)) {
              setList(currentAccessoryList);
            }
          }
          if (+partSequenceMax === +fullSequenceMax) {
            setPartStepCount(partStepLength - 1);
            if (!searchByPair(selectedSystems.SystemReferenceMappings) && !_.isEmpty(updatedData === null || updatedData === void 0 ? void 0 : updatedData.accessoryData)) {
              setCurrentPage(partStepLength * 2 + 1);
              setStepCount(5);
            } else {
              var _selectedSystems$wate, _selectedSystems$Serv13, _selectedSystems$Serv14, _selectedSystems$Serv23, _selectedSystems$Serv24, _selectedSystems$Serv25;
              setAddSystemData({
                description: JSON.stringify({
                  "system_id": "".concat(selectedSystems.systemPartNumber),
                  "model_number": "".concat(selectedSystems.systemModelNumber)
                }),
                partNumber: "",
                installedDate: new Date(selectedSystems.installedDate),
                selectedItems: {
                  ...(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$wate = selectedSystems.waterDest) === null || _selectedSystems$wate === void 0 ? void 0 : _selectedSystems$wate.reduce((item, obj) => {
                    item[obj.name] = obj;
                    return item;
                  }, {}))
                }
              });
              if (selectedSystems !== null && selectedSystems !== void 0 && (_selectedSystems$Serv13 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv14 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv14 === void 0 ? void 0 : _selectedSystems$Serv14.length) - 1]) !== null && _selectedSystems$Serv13 !== void 0 && _selectedSystems$Serv13.ServiceLogImageUrls[0]) {
                var _updatedData$accessor5, _selectedSystems$Serv15, _selectedSystems$Serv16, _selectedSystems$Serv20, _selectedSystems$Serv21, _selectedSystems$Serv22;
                setCurrentPage(partStepLength * 2 + (updatedData !== null && updatedData !== void 0 && (_updatedData$accessor5 = updatedData.accessoryData) !== null && _updatedData$accessor5 !== void 0 && _updatedData$accessor5.length ? 2 : 0) + 4); // +1 initiall make loggic to handle   
                if ((selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv15 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv16 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv16 === void 0 ? void 0 : _selectedSystems$Serv16.length) - 1].ServiceLogImageUrls) === null || _selectedSystems$Serv15 === void 0 ? void 0 : _selectedSystems$Serv15.map(i => i.imageUrl)) !== '') {
                  var _selectedSystems$Serv17, _selectedSystems$Serv18, _selectedSystems$Serv19;
                  fetchImage();
                  setDescription(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv17 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv19 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv19 === void 0 ? void 0 : _selectedSystems$Serv19.length) - 1]) === null || _selectedSystems$Serv17 === void 0 ? void 0 : (_selectedSystems$Serv18 = _selectedSystems$Serv17.ServiceLogImageUrls) === null || _selectedSystems$Serv18 === void 0 ? void 0 : _selectedSystems$Serv18.map(i => i.imageDescription));
                }
                setDetails(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv20 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv22 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv22 === void 0 ? void 0 : _selectedSystems$Serv22.length) - 1]) === null || _selectedSystems$Serv20 === void 0 ? void 0 : (_selectedSystems$Serv21 = _selectedSystems$Serv20.ServiceLogReadings[0]) === null || _selectedSystems$Serv21 === void 0 ? void 0 : _selectedSystems$Serv21.readings);
                setStepCount(10);
              } else if (selectedSystems !== null && selectedSystems !== void 0 && (_selectedSystems$Serv23 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv25 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv25 === void 0 ? void 0 : _selectedSystems$Serv25.length) - 1]) !== null && _selectedSystems$Serv23 !== void 0 && (_selectedSystems$Serv24 = _selectedSystems$Serv23.ServiceLogReadings[0]) !== null && _selectedSystems$Serv24 !== void 0 && _selectedSystems$Serv24.readings) {
                var _updatedData$accessor6, _selectedSystems$Serv26, _selectedSystems$Serv27, _selectedSystems$Serv28;
                setCurrentPage(partStepLength * 2 + (updatedData !== null && updatedData !== void 0 && (_updatedData$accessor6 = updatedData.accessoryData) !== null && _updatedData$accessor6 !== void 0 && _updatedData$accessor6.length ? 2 : 0) + 3); // +1 initiall make loggic to handle                           
                setDetails(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv26 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv28 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv28 === void 0 ? void 0 : _selectedSystems$Serv28.length) - 1]) === null || _selectedSystems$Serv26 === void 0 ? void 0 : (_selectedSystems$Serv27 = _selectedSystems$Serv26.ServiceLogReadings[0]) === null || _selectedSystems$Serv27 === void 0 ? void 0 : _selectedSystems$Serv27.readings);
                setStepCount(9);
              } else if (selectedSystems !== null && selectedSystems !== void 0 && selectedSystems.waterDest) {
                var _updatedData$accessor7;
                setCurrentPage(partStepLength * 2 + (updatedData !== null && updatedData !== void 0 && (_updatedData$accessor7 = updatedData.accessoryData) !== null && _updatedData$accessor7 !== void 0 && _updatedData$accessor7.length ? 2 : 0) + 2); // +1 initiall make loggic to handle                            
                setStepCount(8);
              } else {
                var _updatedData$accessor8;
                fetchImage();
                setCurrentPage(partStepLength * 2 + (updatedData !== null && updatedData !== void 0 && (_updatedData$accessor8 = updatedData.accessoryData) !== null && _updatedData$accessor8 !== void 0 && _updatedData$accessor8.length ? 2 : 0) + 3);
                setStepCount(10);
              }
            }
          } else {
            setCurrentPage(partStepLength * 2 + 1);
            setPartStepCount(partStepLength);
            setStepCount(4);
          }
        }
      }
    };
    customcall();
  }, [systemPartData, updatedData]);
  const calculateAndSetRecovery = () => {
    if (details !== null && details !== void 0 && details.PermeateFlowRate && details !== null && details !== void 0 && details.RejectedFlow) {
      const calculatedRecovery = calculateRecovery();
      setDetails(prevDetails => ({
        ...prevDetails,
        Recovery: calculatedRecovery ? calculatedRecovery : '--'
      }));
    } else {
      setDetails(prevDetails => ({
        ...prevDetails,
        Recovery: '--'
      }));
    }
  };
  (0, _react.useEffect)(() => {
    systemPartData["System Type"] === "RO System" && calculateAndSetRecovery();
  }, [details === null || details === void 0 ? void 0 : details.PermeateFlowRate, details === null || details === void 0 ? void 0 : details.RejectedFlow]);
  const renderPage = stepCount => {
    // eslint-disable-next-line default-case
    switch (stepCount) {
      case 0:
        {
          return /*#__PURE__*/_react.default.createElement(_QrCodeComponent.default, {
            navHeading: "Store Dashboard",
            handleBack: handleCancelbtn,
            headerText: "Add System",
            subContent: "Please scan your system's QR code.",
            btnTitle: "QR Scan",
            bottomBtnTitle: "No QR Code?",
            bottomContent: "Don't have your QR code handy, that's ok! ",
            qrDisabled: true,
            noQrDisabled: false,
            navigateToProvisioningDevice: handleStepCount
          });
        }
      case 1:
        {
          return /*#__PURE__*/_react.default.createElement(_ProvisioningDeviceComponent.default, {
            navHeading: "Store Dashboard",
            handleBack: handleBackStoreDashboard,
            headerText: "Add System",
            subContent: "Enter your part number or description. Or, choose Guided Selection to help find your system quickly. ",
            continueBtnDisabled: addSystemData.description ? false : true,
            continueBtnTitle: "Continue",
            onContinueBtnClick: handleStepCount,
            inputDisabled: false,
            onchange: handleData,
            partinputValue: "",
            partPlaceholder: "Part # or Model Number",
            id: "description",
            value: addSystemData.description,
            partList: partList,
            listEnable: listEnable,
            defaultSystem: defaultSystem,
            backNavigate: nackNavigate,
            productImage: systemImageData === null || systemImageData === void 0 ? void 0 : systemImageData.image_url,
            warningSystemModalData: warningSystemModalData
          });
        }
      case 2:
        {
          var _systemPartData$asset, _systemPartData$asset2, _systemPartData$asset3, _systemPartData$asset4, _systemPartData$asset5;
          return /*#__PURE__*/_react.default.createElement(_ProductFoundComponent.default, {
            productFoundContent: systemPartData !== null && systemPartData !== void 0 && systemPartData.system_id ? "We've found your ".concat(JSON.parse(addSystemData.description).model_number) : "",
            navHeading: "Add System",
            handleBack: handleBack1,
            headerText: systemPartData !== null && systemPartData !== void 0 && systemPartData.system_id ? "Product Found!" : "Product Not Found!",
            partNumberInputDisabled: true,
            description: addSystemData.description,
            onchange: handleData,
            continueBtnTitle: systemPartData !== null && systemPartData !== void 0 && systemPartData.system_id ? "Continue" : "Ok",
            productFoundCont: systemPartData !== null && systemPartData !== void 0 && systemPartData.system_id ? handleStepCount : newStep,
            continueBtnDisabled: false,
            id: "partNumber",
            inputLabel: "Part Number",
            productImage: systemPartData !== null && systemPartData !== void 0 && (_systemPartData$asset = systemPartData.asset) !== null && _systemPartData$asset !== void 0 && _systemPartData$asset.url ? systemPartData === null || systemPartData === void 0 ? void 0 : (_systemPartData$asset2 = systemPartData.asset) === null || _systemPartData$asset2 === void 0 ? void 0 : _systemPartData$asset2.url : _images.default.noImg.default,
            noProductImage: systemPartData !== null && systemPartData !== void 0 && (_systemPartData$asset3 = systemPartData.asset) !== null && _systemPartData$asset3 !== void 0 && _systemPartData$asset3.url ? systemPartData === null || systemPartData === void 0 ? void 0 : (_systemPartData$asset4 = systemPartData.asset) === null || _systemPartData$asset4 === void 0 ? void 0 : _systemPartData$asset4.url : null,
            partNumberInputValue: systemPartData === null || systemPartData === void 0 ? void 0 : (_systemPartData$asset5 = systemPartData.asset) === null || _systemPartData$asset5 === void 0 ? void 0 : _systemPartData$asset5.sku_id,
            isLoading: isLoading
          });
        }
      case 3:
        {
          return /*#__PURE__*/_react.default.createElement(_RepalceFilterComponent.default, {
            navHeading: "Add System",
            rightNavHeading: "Cancel",
            handleCancle: handleCancelbtn,
            handleBack: handleBack1,
            headerText: "Add Install Date",
            addDateContent: "When was the system installed?",
            InstallationDateTxt: "Installation Date",
            saveContinueBtnTitle: "Save and Continue",
            saveContinueBtnDisabled: addSystemData.installedDate ? false : true,
            saveContinueBtnClick: handleStepCount,
            id: "installedDate",
            value: addSystemData.installedDate,
            onchange: handleData,
            modelNumber: "".concat(JSON.parse(addSystemData.description).system_id + " " + JSON.parse(addSystemData.description).model_number)
          });
        }
      case 4:
        {
          return /*#__PURE__*/_react.default.createElement(_PartSteper.default, {
            Loader: /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null),
            loadingFlag: dataLoading,
            steperComponent: steperComponent,
            stepCount: partStepCount
          });
        }
      case 5:
        {
          var _updatedData$accessor9;
          return (updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$accessor9 = updatedData.accessoryData) === null || _updatedData$accessor9 === void 0 ? void 0 : _updatedData$accessor9.length) > 0 && /*#__PURE__*/_react.default.createElement(_AddAccessoryComponent.default, {
            totalPage: totalPage,
            currentPage: currentPage,
            navHeading: "".concat(Object.keys(updatedData === null || updatedData === void 0 ? void 0 : updatedData.partData).length > 0 ? "Choose Filter" : "Add System"),
            rightNavHeading: "Cancel",
            handleCancle: handleCancelbtn,
            handleBack: handleAccessoryBack,
            headerText: "Add Accessory",
            subContent: "These are accessories available for the ME-HE2.",
            continueBtnTitle: "Continue",
            continueBtnClick: handleStepCount,
            continueBtnDisabled: handleAccessoryBtnDisable(),
            accessoryList: accessoryList,
            handleReduceBtn: handleReduceBtn,
            handleAddBtn: handleAddBtn,
            modelNumber: updatedData.system_id + " " + updatedData["Model Number"]
          });
        }
      case 6:
        {
          var _updatedData$accessor10;
          return (updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$accessor10 = updatedData.accessoryData) === null || _updatedData$accessor10 === void 0 ? void 0 : _updatedData$accessor10.length) > 0 && /*#__PURE__*/_react.default.createElement(_AddAccessoryInstallationComponent.default, {
            totalPage: totalPage,
            minDate: new Date(systemDate),
            currentPage: currentPage,
            modelNumber: updatedData.system_id + " " + updatedData["Model Number"],
            navHeading: "Add Accessory",
            rightNavHeading: "Cancel",
            handleCancle: handleCancelbtn,
            handleBack: handleBack,
            headerText: "Add Installation Date",
            list: list,
            preText: "What was the installation date?",
            installationText: "Installation Date",
            dateChange: dateChange,
            bottomBtnTitle: "Save and Continue",
            navigateToProvisioningDevice: handleStepCount,
            noQrDisabled: handleAccInstallationBtn()
          });
        }
      case 7:
        {
          var _updatedData$accessor11;
          return /*#__PURE__*/_react.default.createElement(_VsPumpSetupComponent.default, {
            totalPage: totalPage,
            minDate: new Date(systemDate),
            currentPage: currentPage,
            modelNumber: "".concat(JSON.parse(addSystemData.description).system_id + " " + JSON.parse(addSystemData.description).model_number),
            navHeading: "".concat((updatedData === null || updatedData === void 0 ? void 0 : (_updatedData$accessor11 = updatedData.accessoryData) === null || _updatedData$accessor11 === void 0 ? void 0 : _updatedData$accessor11.length) > 0 ? "Add Accessory" : "Previous Filter"),
            rightNavHeading: "Cancel",
            headerText: "Where is the water going?",
            handleCancle: handleCancelbtn,
            handleBack: handleLastStepBack,
            pumpSetupContent: "Please select a water destination for your system.",
            aboutWaterContent: "About Water Destinations",
            saveContinueBtnTitle: "Save and Continue",
            pumpSetupBottomContent: "Minimum 1 water destination.",
            saveContinueBtnClick: handleStepCount,
            saveContinueBtnDisabled: addSystemData.selectedItems.Hot || addSystemData.selectedItems.Ice || addSystemData.selectedItems.Steam || addSystemData.selectedItems.Fountain ? false : true,
            openWaterModal: openWaterModal,
            positiveActionButtonTitle: "Ok",
            modalHeaderText: "About Water Destinations",
            handleWaterModal: handleWaterModal,
            id: "selectedItems",
            onchange: handleData,
            handleCheckBoxSelection: handleCheckBoxSelection,
            selectedItems: addSystemData.selectedItems,
            shouldCheckBoxDisabled: shouldCheckBoxDisabled,
            successModalBtnTitle: "Continue",
            items: _strings.items,
            imageData: _strings.imageData,
            isUpdating: isUpdating,
            isAccessoryPresent: list.length ? true : false
          });
        }
      case 8:
        {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ServiceHistoryDetails.default, {
            onKeyPress: onKeyPress,
            currentPage: currentPage,
            totalPage: totalPage,
            backNavigationScreen: 'Water Destination',
            subHeaderText: "Water Info",
            handleBack: handleBack,
            handleCancle: handleCancelbtn,
            isLoading: isLoading,
            rightNavHeading: "Cancel",
            headerText: "Water Info",
            subText: "".concat(JSON.parse(addSystemData.description).system_id + " " + JSON.parse(addSystemData.description).model_number),
            subContent: 'Almost there! just few more optional steps',
            saveBtnClick: handleStepCount,
            isRo: systemPartData["System Type"] === "RO System" ? true : false,
            pretreatmentValue: details.pretreatmentValue,
            pretreatmentChecked: pretreatmentChecked,
            details: details,
            isUpdating: isUpdating,
            onChangeInletTds: e => setDetails({
              ...details,
              InletTds: e.target.value
            }),
            onChangeInletHardness: e => setDetails({
              ...details,
              InletHardness: e.target.value
            }),
            onChangeInletTemp: e => setDetails({
              ...details,
              InletTemp: e.target.value
            }),
            onChangeInletPressure: e => setDetails({
              ...details,
              InletPressure: e.target.value
            }),
            onChangepressureDrop: e => setDetails({
              ...details,
              pressureDrop: e.target.value
            }),
            onChangePermeateTds: e => setDetails({
              ...details,
              PermeateTds: e.target.value
            }),
            onChangeRejectTds: e => setDetails({
              ...details,
              RejectTds: e.target.value
            }),
            onChangePermeateFlowRate: e => setDetails({
              ...details,
              PermeateFlowRate: e.target.value
            }),
            onChangeRejectedFlow: e => setDetails({
              ...details,
              RejectedFlow: e.target.value
            }),
            onChangeBlendedTds: e => setDetails({
              ...details,
              BlendedTds: e.target.value
            }),
            onChangePreCharge: e => setDetails({
              ...details,
              preCharge: e.target.value
            }),
            onChangeRecovery: e => setDetails({
              ...details,
              Recovery: e.target.value
            })
          }));
        }
      case 9:
        {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ImageUpload.default, {
            isUpdating: isUpdating,
            currentPage: currentPage,
            totalPage: totalPage,
            navHeading: 'Water Info',
            onBackPress: handleBack,
            onClickCancel: handleCancelbtn,
            leftArrow: _images.default.leftArrow.default,
            cancelText: 'Cancel',
            headerText: 'Add Photos',
            subText: "".concat(JSON.parse(addSystemData.description).system_id + " " + JSON.parse(addSystemData.description).model_number),
            subContent: 'Add Photos',
            description: description,
            uploadDisabled: (path === null || path === void 0 ? void 0 : path.length) == 10 ? true : false,
            descriptionChange: (e, index) => {
              const newInput = e.target.value;
              const descriptionList = [...description];
              descriptionList[index] = newInput;
              setDescription(descriptionList);
            },
            buttonTitle: 'Upload Photos',
            uploadPhotos: uploadPhotos,
            checkmark: _images.default.checkmark.default,
            checkmarkStyle: {
              marginLeft: '303px',
              marginTop: '-40px'
            },
            displayPhotosModal: displayModal,
            isOneSelected: isOneSelected,
            onOptionSelect: onOptionSelect,
            isTwoSelected: isTwoSelected,
            cameraStream: cameraStream,
            videoRef: videoRef,
            handleFileChange: handleFileChange,
            onModalCancel: onModalCancel,
            selectedImages: selectedImages,
            limitExceededText: 'Limit Exceeded',
            limitDetailText: noImage ? 'You can upload maximum 10 photos only.' : "Maximum 10 photos can be uploaded. ".concat(10 - path.length, " photos remaining."),
            deleteIcon: _images.default.delete.default,
            okText: 'Ok',
            isLimitExceeded: isLimitExceeded,
            limitOkPress: limitOkPress,
            deleteIconClick: deleteIconClick,
            imagePlaceholder: 'Add Description',
            continueText: 'Save and Continue',
            saveText: 'Continue',
            deleteText: 'Continue',
            continueClicked: handleStepCount,
            deleteModal: deleteModal,
            trash: _images.default.trash.default,
            onCancelDelete: onCancelDelete,
            deleteHandler: deleteHandler,
            continuePress: true,
            camDivStyle: {
              backgroundColor: '#006E96',
              justifyContent: 'center',
              width: '100%',
              height: '45px',
              borderRadius: 10,
              color: '#fff '
            },
            camLabelStyle: {
              width: '100%',
              height: '45px',
              fontWeight: 700,
              marginTop: '10px',
              textAlign: "center"
            },
            hideImageButton: {
              width: '100%',
              height: '45px',
              display: 'none'
            },
            windowLayout: windowLayout,
            uploadingVisible: uploadingVisible,
            uploading: uploading,
            totalImagesUploaded: totalImagesUploaded,
            totalImagesSelected: totalImagesSelected,
            notUploaded: notUploaded,
            imageNotUploadedClick: imageNotUploadedClick
          }));
        }
      case 10:
        {
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AddNotes.default, {
            currentPage: currentPage,
            isUpdating: isUpdating,
            totalPage: totalPage,
            navHeading: 'Add Photos',
            onBackPress: handleBack,
            onClickCancel: handleCancelbtn,
            leftArrow: _images.default.leftArrow.default,
            cancelText: 'Cancel',
            subNotesText: charCount === 250 ? "Maximum character limit : 250" : "You have ".concat(charCount, " characters remaining"),
            headerText: 'Add Notes',
            subText: "".concat(JSON.parse(addSystemData.description).system_id + " " + JSON.parse(addSystemData.description).model_number),
            addNotesHeader: 'Add Notes',
            notesText: notesText,
            onChangeNotes: onChangeNotes,
            saveText: 'Save and Submit',
            onClickSave: handleAddSystem,
            showSuccessModal: showSuccessModal,
            handleSuccessModal: handleSuccessModal,
            successModalBtnTitle: "Continue",
            successModalData: successModalData,
            isAccessoryPresent: list.length ? true : false,
            detailsArray: detailsArray
          }));
        }
    }
  };
  return renderPage(stepCount);
};
var _default = exports.default = AddSystem;